
        var result = require("!!../../../../node_modules/css-loader/index.js!./customers-add-update.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/customers/customers-add-update.component.css
// module id = 643
// module chunks = 0